import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import Row from '../../Structure/Row';
import Input from '../../Input';
import Button from '../../Button';
import Group from '../../Structure/Group';
import ModalConstructor from '../ModalConstructor';
import { prepareModalData } from '../../../utils/prepareModalData';
import { API_getAboutObject, API_getAboutObjectEditAndDeleteUrl, API_URL_GET_ABOUT_OBJECT_SET_POSITIONS } from '../../../utils/api';

const EditObjectCharacteristicsModal = (props) => {
  const { item, isEditable, hideModal, appendAfterId, allIds, contractId, objectId } = prepareModalData(props);
  const characteristicId = item.id;

  const getFetchRequestUrl = useCallback((isEditable) => {
    const requestUrl = isEditable ?
      API_getAboutObjectEditAndDeleteUrl(characteristicId) :
      API_getAboutObject();

    return requestUrl;
  }, [isEditable, characteristicId]);

  const characteristicsFieldsData = {
    name: {
      required: true,
      value: item.name || '',
      errorText: '',
    },
    value: {
      required: true,
      value: item.value || '',
      errorText: '',
    },
    contract_id: {
      value: contractId,
      needToSendAlways: true,
    },
    contract_object_id: {
      value: objectId,
      needToSendAlways: true,
    }
  };

  const getTemplate = (templateProps) => {
    const {
      fieldsData,
      submitButtonText,
      handleForm,
      onCloseAction,
      onSubmitAction,
    } = templateProps;

    const getFieldProps = (name) => {
      return {
        name,
        value: fieldsData[name].value,
        required: fieldsData[name].required,
        errorText: fieldsData[name].errorText,
      };
    };

    return (
      <>
        <Row>
          <Input
            placeholder='Наименование характеристики'
            label='Наименование'
            onChange={handleForm}
            {...getFieldProps('name')}
          />
        </Row>
        <Row>
          <Input
            placeholder='Значение характеристики'
            label='Значение'
            onChange={handleForm}
            {...getFieldProps('value')}
          />
        </Row>
        <Group align='right'>
          <Button label='Закрыть' theme='hollow' onClick={onCloseAction} />
          <Button label={submitButtonText} onClick={onSubmitAction} />
        </Group>
      </>
    );
  };

  const editModalProps = {
    fieldsData: characteristicsFieldsData,

    getFetchRequestUrl,
    getTemplate,

    hideModal,
    isEditable,

    appendAfterId,

    ALL_OBJECT_IDS: allIds,
    SET_POSITIONS_URL: API_URL_GET_ABOUT_OBJECT_SET_POSITIONS,
  };

  return <ModalConstructor {...editModalProps} />
};

EditObjectCharacteristicsModal.propTypes = {
  hideModal: PropTypes.func.isRequired,
};

export default EditObjectCharacteristicsModal;